import React, { createContext, useContext, useState, useEffect } from 'react';

const VendorContext = createContext();

export const VendorProvider = ({ children }) => {
  const [isMerchant, setIsMerchant] = useState(() => {
    return localStorage.getItem('em_role') === 'merchant';
  });

  const [vendorData, setVendorData] = useState({
    shopName: "Sacred Blooms & Co",
    balance: 4250.80,
    pendingBalance: 1200.00,
    totalSales: 124,
    rating: 4.9,
    bankAccount: "**** 8842",
    payoutHistory: [
      { id: 'w1', amount: 1500, date: '2024-03-01', status: 'Completed' },
      { id: 'w2', amount: 800,  date: '2024-03-15', status: 'Processing' },
      { id: 'w3', amount: 2200, date: '2024-02-01', status: 'Completed' },
      { id: 'w4', amount: 950,  date: '2024-01-15', status: 'Completed' },
    ],
  });

  const toggleMerchantRole = () => {
    const newRole = !isMerchant;
    setIsMerchant(newRole);
    localStorage.setItem('em_role', newRole ? 'merchant' : 'customer');
  };

  const requestWithdrawal = (amount) => {
    if (amount > vendorData.balance) return false;
    setVendorData(prev => ({
      ...prev,
      balance: prev.balance - amount,
      payoutHistory: [
        { id: Date.now(), amount, date: new Date().toISOString().split('T')[0], status: 'Processing' },
        ...prev.payoutHistory,
      ],
    }));
    return true;
  };

  return (
    <VendorContext.Provider value={{ isMerchant, toggleMerchantRole, vendorData, requestWithdrawal }}>
      {children}
    </VendorContext.Provider>
  );
};

export const useVendor = () => useContext(VendorContext);